// import { useRef, useState } from "react";
// import PauseIcon from '@mui/icons-material/Pause';
// import { Card, CardMedia, CardContent, CardActions, Avatar, IconButton, Typography, Grid, Box, Menu, MenuItem } from '@mui/material';
// import { Modal, TextField, Button } from "@mui/material";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import ChatIcon from '@mui/icons-material/Chat';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import { useDispatch, useSelector } from "react-redux";
// import { uplodateLoading } from "../../../redux/features/common/commonSlice";
// import urls from "../../constants/apiurl";
// import ApiCaller from "../../constants/ApiCaller";
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { EditVideo } from "./EditVideo";
// import EditIcon from '@mui/icons-material/Edit';

// export const VideoRewardCard = ({ id, totalViews, totalLikes, totalComments, approved, rewarded, profileDetails, thumbnail, link, eventId, postions, eventDetails, defaultVideoRewardPrice,
//     handlePlay, handlePause, menuEnable, onClick, style, editPrice, videoReward, categoryList, languageList, videoContentType, getVideoList }) => {
//     const userData = useSelector(state => state?.userData)
//     const dispatch = useDispatch()
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [showEditVideo, setShowEditVideo] = useState(false)

//     const [isEditingPrice, setIsEditingPrice] = useState(false);
//     const [newPrice, setNewPrice] = useState(defaultVideoRewardPrice ? defaultVideoRewardPrice : 0);
//     const [price, setPrice] = useState(8); // Initial price
//     const videoRef = useRef(null);
//     const [selectedVideoDetails, setSelectedVideoDetails] = useState({})
//     const [isPlaying, setIsPlaying] = useState(false);

//     const handlePlayPause = () => {
//         if (isPlaying) {
//             videoRef.current.pause();
//         } else {
//             videoRef.current.play();
//         }
//         setIsPlaying(!isPlaying);
//     };

//     const handleMenuOpen = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleMenuClose = () => {
//         setAnchorEl(null);
//     };


//     const handleEditPriceClick = () => {
//         setIsEditingPrice(true);
//         handleMenuClose();
//     };

//     const handleSavePrice = () => {
//         setPrice(newPrice); // Save the new price
//         setIsEditingPrice(false); // Close the modal
//         editPrice(newPrice)
//     };

//     var settings = {
//         dots: false,
//         infinite: categoryList?.length > 4 ? true : false,
//         variableWidth: true,
//         arrows: false,
//         autoplay: true,
//         speed: 500,
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         initialSlide: 0,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 3,
//                     infinite: true,
//                     dots: true
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 2,
//                     initialSlide: 2
//                 }
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1
//                 }
//             }
//         ]
//     };

//     const getvideoContentType = (videoContentType) => {
//         const map = {
//             EVERYONE: "Everyone",
//             EIGHTEEN_PLUS: "18+",
//             BELOW_EIGHTEEN: "Below 18"
//         };
//         return map[videoContentType] || "Unknown";
//     };

//     return (
//         <>
//             <Card sx={{ width: '100%', position: 'relative', margin: '0 auto' }} style={style} >
//                 {videoReward > 0 ? <Box
//                     sx={{
//                         position: 'absolute',
//                         top: '16px',
//                         right: '-20px',
//                         backgroundColor: 'gold',
//                         color: 'black',
//                         fontWeight: 'bold',
//                         textAlign: 'center',
//                         transform: 'rotate(45deg)',
//                         width: '120px',
//                         fontSize: '12px',
//                         zIndex: 2,
//                         pointerEvents: 'none', // Ensures the ribbon doesn't interfere with other elements
//                     }}
//                 >
//                     Rewarded
//                 </Box> : <></>}
//                 {approved ? <Box
//                     sx={{
//                         position: 'absolute',
//                         top: '0px',
//                         right: '166px',
//                         backgroundColor: 'gold',
//                         color: 'black',
//                         fontWeight: 'bold',
//                         textAlign: 'center',
//                         transform: 'rotate(0deg)',
//                         width: '120px',
//                         fontSize: '12px',
//                         zIndex: 2,
//                         pointerEvents: 'none', // Ensures the ribbon doesn't interfere with other elements
//                     }}
//                 >
//                     Approved
//                 </Box> : <></>}
//                 {videoReward > 0 ? <Box
//                     sx={{
//                         position: 'absolute',
//                         bottom: '8px',
//                         right: '8px',
//                         backgroundColor: 'gold',
//                         color: 'black',
//                         fontWeight: 'bold',
//                         padding: '4px 8px',
//                         borderRadius: '8px',
//                         fontSize: '12px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         zIndex: 2,
//                     }}
//                 >
//                     <img src="https://png.pngtree.com/png-vector/20220609/ourmid/pngtree-gold-money-coins-icon-png-image_4833369.png" alt="Reward Coin" width="24" height="24" style={{ marginRight: '4px' }} />
//                     {videoReward} {/* Replace with actual reward coin count */}
//                 </Box> : <></>}


//                 <Box sx={{ position: 'relative' }} >
//                     <video
//                         height="200"
//                         src={link} // Replace with your video URL
//                         alt="Video"
//                         controls={false} // Disable default controls
//                         ref={videoRef}
//                         onError={(e) => {
//                             e.target.onerror = null; // Prevents infinite loop
//                             e.target.src = "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"; // Fallback image URL
//                         }}
//                         style={{
//                             width: '100%',
//                             objectFit: 'cover',
//                         }}
//                     ></video>

//                     {/* Play/Pause button overlay */}
//                     <IconButton
//                         sx={{
//                             position: 'absolute',
//                             top: '50%',
//                             left: '50%',
//                             transform: 'translate(-50%, -50%)',
//                             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                             color: 'white',
//                             '&:hover': {
//                                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//                             },
//                         }}
//                         aria-label="play video"
//                         onClick={() => handlePlayPause()}
//                     >
//                         {isPlaying ? <PauseIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
//                     </IconButton>
//                     {menuEnable ? <>
//                         <IconButton
//                             aria-label="settings"
//                             onClick={handleMenuOpen}
//                             sx={{
//                                 position: 'absolute',
//                                 top: 8,
//                                 right: 8,
//                                 color: 'rgba(255, 255, 255, 0.7)',
//                             }}
//                         >
//                             <MoreVertIcon />
//                         </IconButton>

//                         <Menu
//                             anchorEl={anchorEl}
//                             open={Boolean(anchorEl)}
//                             onClose={handleMenuClose}
//                         >
//                             <MenuItem onClick={handleEditPriceClick}>Edit Price</MenuItem>
//                             {/* <MenuItem onClick={() => editPrice(8)}>Edit Price</MenuItem> */}
//                             <MenuItem onClick={() => {
//                                 handleMenuClose()
//                                 handlePlay(link)
//                             }}>Full Preview</MenuItem>
//                         </Menu>
//                     </> : <></>}

//                 </Box>
//                 {/* Modal for editing the price */}
//                 <Modal
//                     open={isEditingPrice}
//                     onClose={() => setIsEditingPrice(false)}
//                     aria-labelledby="edit-price-modal"
//                     aria-describedby="edit-price-description"
//                 >
//                     <Box
//                         sx={{
//                             position: "absolute",
//                             top: "50%",
//                             left: "50%",
//                             transform: "translate(-50%, -50%)",
//                             bgcolor: "background.paper",
//                             boxShadow: 24,
//                             p: 4,
//                             borderRadius: 2,
//                             minWidth: 300,
//                         }}
//                     >
//                         <h2 id="edit-price-modal">Edit Price</h2>
//                         <TextField
//                             fullWidth
//                             label="Price"
//                             type="number"
//                             value={newPrice}
//                             onChange={(e) => setNewPrice(e.target.value)}
//                             autoFocus
//                         />
//                         <Box
//                             sx={{
//                                 display: "flex",
//                                 justifyContent: "flex-end",
//                                 mt: 2,
//                             }}
//                         >
//                             <Button onClick={() => setIsEditingPrice(false)}>Cancel</Button>
//                             <Button
//                                 onClick={handleSavePrice}
//                                 sx={{ ml: 2 }}
//                                 variant="contained"
//                             >
//                                 Save
//                             </Button>
//                         </Box>
//                     </Box>
//                 </Modal>
//                 <div>
//                     <div onClick={(e) => onClick(e)}>
//                         {/* <div onClick={!rewarded ? (e) => onClick(e) : onClick(e)}> */}
//                         <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
//                             <Avatar sx={{ mr: 1 }} src={profileDetails?.profileUrl || undefined}>
//                                 {!profileDetails?.profileUrl && profileDetails?.userName.charAt(0).toUpperCase()}
//                             </Avatar>
//                             <Typography variant="subtitle2">{profileDetails?.userName}</Typography>

//                         </CardContent>

//                         <div className="slider-container video_slider">
//                             <div>
//                                 <span className="text-left mb-2 d-block">Age: <b>{getvideoContentType(videoContentType)}</b></span>
//                                 <span className="mb-2 d-block">Category:</span>
//                                 <Slider {...settings} className="mb-2">
//                                     {categoryList?.map((category, index) => {
//                                         return (
//                                             <>

//                                                 <div className="video_manager_list">
//                                                     <span>{category}</span>
//                                                 </div>
//                                             </>
//                                         )
//                                     })}
//                                 </Slider>
//                             </div>
//                             <div>
//                                 <span className="mb-2 d-block">Language:</span>
//                                 <Slider {...settings}>
//                                     {languageList?.map((language, index) => {
//                                         return (
//                                             <>
//                                                 <div className="video_manager_list">
//                                                     <span>{language}</span>
//                                                 </div>
//                                             </>
//                                         )
//                                     })}
//                                 </Slider>
//                             </div>
//                         </div>
//                         <CardActions >
//                             <IconButton aria-label="add to favorites">
//                                 <FavoriteIcon />
//                             </IconButton>
//                             <Typography variant="caption">{totalLikes}</Typography>
//                             <IconButton aria-label="star">
//                                 <VisibilityIcon />
//                             </IconButton>
//                             <Typography variant="caption">{totalViews}</Typography>
//                             <IconButton aria-label="star">
//                                 <ChatIcon />
//                             </IconButton>
//                             <Typography variant="caption">{totalComments}</Typography>
//                             <IconButton aria-label="star" onClick={() => {
//                                 setShowEditVideo(true)
//                                 setSelectedVideoDetails({ languageList, categoryList, videoContentType, id })
//                             }}>
//                                 <EditIcon />
//                             </IconButton>
//                         </CardActions>
//                         {/* <a
//                             className='dropdown-item cursor'
//                             onClick={() => {
//                                 setShowEditVideo(true)
//                                 setSelectedVideoDetails({ languageList, categoryList, videoContentType, id })
//                             }
//                             }
//                         >
//                             Edit
//                         </a> */}
//                     </div>
//                 </div>
//                 <EditVideo
//                     show={showEditVideo}
//                     selectedVideoDetails={selectedVideoDetails}
//                     getVideoList={getVideoList}
//                     onHide={() => setShowEditVideo(false)}
//                 />
//             </Card>

//         </>
//     );
// }



import { useState } from "react";
import { Card, CardContent, CardActions, Avatar, IconButton, Typography, Box, Menu, MenuItem, Modal, TextField, Button, Tooltip, Chip, Switch } from '@mui/material'; // 👈 2. IMPORT Chip & Tooltip & Switch
import VisibilityIcon from '@mui/icons-material/Visibility';
import ChatIcon from '@mui/icons-material/Chat';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from "react-redux";
import FavoriteIcon from '@mui/icons-material/Favorite';
import React from "react";
import { EditVideo } from "./EditVideo";
import EditIcon from '@mui/icons-material/Edit';
import VerifiedIcon from '@mui/icons-material/Verified'; // 👈 3. IMPORT
import Utils from '../../constants/Utils';

// ❌ 4. REMOVED Slider and "slick-carousel" imports (no longer needed)

export const VideoRewardCard = ({ id, totalViews, totalLikes, totalComments, approved, rewarded, profileDetails, thumbnail, link, images, eventId, postions, eventDetails, defaultVideoRewardPrice,
    handlePlay, handlePause, menuEnable, onClick, style, editPrice, videoReward, categoryList, languageList, videoContentType, getVideoList, active, handleStatusChange, videoRecord, createdAt, updatedAt, onRewardAction }) => {
    // const userData = useSelector(state => state?.userData)
    // const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = useState(null);
    const [showEditVideo, setShowEditVideo] = useState(false)
    // const navigate = useNavigate(); // 👈 5. INITIALIZE useNavigate

    const [isEditingPrice, setIsEditingPrice] = useState(false);
    const [newPrice, setNewPrice] = useState(defaultVideoRewardPrice ? defaultVideoRewardPrice : 0);
    // const [price, setPrice] = useState(8); // Initial price
    const [selectedVideoDetails, setSelectedVideoDetails] = useState({})
    const { formatDate } = Utils();

    const videoUpdatedLabel = formatDate(updatedAt || createdAt);

    const openFullPreview = (e) => {
        e.stopPropagation()
        const payload = videoRecord || {
          id,
          link,
          images,
          profileDetails,
          thumbnail,
          totalViews,
          totalLikes,
          totalComments,
          rewarded,
          approved,
          active,
          categoryList,
          languageList,
          videoContentType,
          videoReward
        }
        if (handlePlay) {
            handlePlay(payload)
        }
    }

    // 👈 7. HANDLER for clicking user's name/avatar
    const handleUserClick = (e) => {
        // Stop the card's main onClick (for selection) from firing
        e.stopPropagation();

        // ⚠️ IMPORTANT: Change '/user-details/' to your app's route
        window.open(`/user-manager/${profileDetails?.id}`, '_blank');
    };

    const handleMenuOpen = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (e) => {
        e.stopPropagation();
        setAnchorEl(null);
    };

    const handleEditPriceClick = (e) => {
        e.stopPropagation();
        setIsEditingPrice(true);
        handleMenuClose(e);
    };

    const handleSavePrice = () => {
        // setPrice(newPrice); // Save the new price
        setIsEditingPrice(false); // Close the modal
        editPrice(newPrice)
    };

    // ❌ 8. REMOVED the 'settings' object for react-slick

    const getvideoContentType = (videoContentType) => {
        const map = {
            EVERYONE: "Everyone",
            EIGHTEEN_PLUS: "18+",
            BELOW_EIGHTEEN: "Below 18"
        };
        return map[videoContentType] || "Unknown";
    };

    return (
        <>
            <Card sx={{ width: '100%', position: 'relative', margin: '0 auto', borderRadius: '8px' }} style={style} >

                {/* --- RIBBONS AND BADGES --- */}
                {videoReward > 0 && <Box
                    sx={{
                        position: 'absolute', top: '16px', right: '-20px',
                        backgroundColor: 'gold', color: 'black', fontWeight: 'bold',
                        textAlign: 'center', transform: 'rotate(45deg)',
                        width: '120px', fontSize: '12px', zIndex: 2,
                        pointerEvents: 'none',
                    }}
                >
                    Rewarded
                </Box>}

                {/* 🎨 9. UPDATED "Approved" badge to be a cleaner icon */}
                {approved && (
                    <Tooltip title="Approved">
                        <VerifiedIcon
                            color="primary"
                            sx={{
                                position: 'absolute', top: 8, left: 8,
                                color: 'white', backgroundColor: '#1976d2',
                                borderRadius: '50%', zIndex: 2, fontSize: '28px',
                                pointerEvents: 'none',
                            }}
                        />
                    </Tooltip>
                )}

                {videoReward > 0 && <Box
                    sx={{
                        position: 'absolute', bottom: '8px', right: '8px',
                        backgroundColor: 'gold', color: 'black', fontWeight: 'bold',
                        padding: '4px 8px', borderRadius: '8px', fontSize: '12px',
                        display: 'flex', alignItems: 'center', zIndex: 2,
                    }}
                >
                    <img src="https://png.pngtree.com/png-vector/20220609/ourmid/pngtree-gold-money-coins-icon-png-image_4833369.png" alt="Reward Coin" width="24" height="24" style={{ marginRight: '4px' }} />
                    {videoReward}
                </Box>}


                {/* --- VIDEO THUMB (full playback opens in modal) --- */}
                <Box sx={{ position: 'relative', height: 200, bgcolor: '#1a1a1a' }} >
                    {thumbnail ? (
                        <img
                            src={thumbnail}
                            alt=""
                            style={{
                                width: '100%',
                                height: 200,
                                objectFit: 'cover',
                                display: 'block'
                            }}
                            onError={(e) => {
                                e.target.onerror = null
                                e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                height: 200,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'text.secondary',
                                fontSize: 12
                            }}
                        >
                            No thumbnail
                        </Box>
                    )}

                    <IconButton
                        sx={{
                            position: 'absolute', top: '50%', left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.55)',
                            color: 'white',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.75)' },
                        }}
                        aria-label="play video in full preview"
                        onClick={openFullPreview}
                    >
                        <PlayArrowIcon fontSize="large" />
                    </IconButton>

                    {(menuEnable !== false) && (
                        <>
                            <IconButton
                                aria-label="settings"
                                onClick={handleMenuOpen}
                                sx={{
                                    position: 'absolute', top: 8, right: 8,
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                }}
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                            >
                                {onRewardAction && (
                                    <>
                                        <MenuItem onClick={(e) => {
                                            handleMenuClose(e);
                                            onRewardAction('ONLY_REWARD');
                                        }}>Only Reward</MenuItem>
                                        <MenuItem onClick={(e) => {
                                            handleMenuClose(e);
                                            onRewardAction('APPROVE_REWARD');
                                        }}>Approve and Reward</MenuItem>
                                        <MenuItem onClick={(e) => {
                                            handleMenuClose(e);
                                            onRewardAction('ONLY_APPROVE');
                                        }}>Only Approve</MenuItem>
                                    </>
                                )}
                                <MenuItem onClick={handleEditPriceClick}>Edit Price</MenuItem>
                                <MenuItem onClick={(e) => {
                                    handleMenuClose(e);
                                    openFullPreview(e)
                                }}>Full Preview</MenuItem>
                            </Menu>
                        </>
                    )}
                </Box>

                {/* --- MODAL (Unchanged) --- */}
                <Modal
                    open={isEditingPrice}
                    onClose={() => setIsEditingPrice(false)}
                    aria-labelledby="edit-price-modal"
                >
                    <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, minWidth: 300 }}>
                        <h2 id="edit-price-modal">Edit Price</h2>
                        <TextField
                            fullWidth label="Price" type="number"
                            value={newPrice}
                            onChange={(e) => setNewPrice(e.target.value)}
                            autoFocus
                        />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button onClick={() => setIsEditingPrice(false)}>Cancel</Button>
                            <Button onClick={handleSavePrice} sx={{ ml: 2 }} variant="contained">
                                Save
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                {/* --- CARD CONTENT (Wrapped in Card's main onClick) --- */}
                <div onClick={(e) => onClick(e)} style={{ cursor: 'pointer' }}>

                    {/* 👈 10. UPDATED User Info Section */}
                    <CardContent sx={{ display: 'flex', alignItems: 'center', pb: 0, pt: 2, px: 2 }}>
                        <Avatar
                            sx={{ mr: 1.5, cursor: 'pointer', width: 40, height: 40 }}
                            src={profileDetails?.profileUrl || undefined}
                            onClick={handleUserClick} // 👈 Click handler
                        >
                            {!profileDetails?.profileUrl && profileDetails?.userName.charAt(0).toUpperCase()}
                        </Avatar>
                        <Typography
                            variant="subtitle2"
                            noWrap
                            sx={{
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                '&:hover': { textDecoration: 'underline' }
                            }}
                            onClick={handleUserClick} // 👈 Click handler
                        >
                            {profileDetails?.userName}
                        </Typography>
                    </CardContent>

                    {/* 🎨 11. REPLACED Sliders with Chips */}
                    <Box sx={{ px: 2, py: 1 }}>
                        <Typography variant="body2" sx={{ mb: 0.5, fontSize: '0.8rem' }}>
                            Age: <strong style={{ color: '#111' }}>{getvideoContentType(videoContentType)}</strong>
                        </Typography>

                        {/* Category Chips */}
                        <Typography variant="body2" sx={{ mb: 0.5, mt: 1, fontSize: '0.8rem', color: 'text.secondary' }}>Category:</Typography>
                        <Box sx={{ display: 'flex', overflowX: 'auto', pb: 0.5, '::-webkit-scrollbar': { height: '4px' }, '::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '4px' } }}>
                            {categoryList?.length > 0 ? categoryList.map((category, index) => (
                                <Chip key={index} label={category} size="small" sx={{ mr: 0.5, backgroundColor: '#eee', fontSize: '0.75rem' }} />
                            )) : <Typography variant="caption" color="text.secondary">No category</Typography>}
                        </Box>

                        {/* Language Chips */}
                        <Typography variant="body2" sx={{ mb: 0.5, mt: 1, fontSize: '0.8rem', color: 'text.secondary' }}>Language:</Typography>
                        <Box sx={{ display: 'flex', overflowX: 'auto', pb: 0.5, '::-webkit-scrollbar': { height: '4px' }, '::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '4px' } }}>
                            {languageList?.length > 0 ? languageList.map((language, index) => (
                                <Chip key={index} label={language} size="small" sx={{ mr: 0.5, backgroundColor: '#e0f7fa', fontSize: '0.75rem' }} />
                            )) : <Typography variant="caption" color="text.secondary">No language</Typography>}
                        </Box>
                    </Box>

                    {videoUpdatedLabel ? (
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', px: 2, pb: 0.5 }}
                        >
                            Updated: {videoUpdatedLabel}
                        </Typography>
                    ) : null}

                    {/* 🎨 12. STREAMLINED Stats Section */}
                    <CardActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 0, pb: 1, px: 2 }}>
                        {/* Left-aligned Stats */}
                        <Box sx={{ display: 'flex', gap: { xs: 1, sm: 1.5 }, alignItems: 'center', color: 'text.secondary', flexWrap: 'wrap' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                <FavoriteIcon sx={{ fontSize: '16px' }} />
                                <Typography variant="caption" sx={{ fontWeight: '500' }}>{totalLikes}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                <VisibilityIcon sx={{ fontSize: '16px' }} />
                                <Typography variant="caption" sx={{ fontWeight: '500' }}>{totalViews}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                <ChatIcon sx={{ fontSize: '16px' }} />
                                <Typography variant="caption" sx={{ fontWeight: '500' }}>{totalComments}</Typography>
                            </Box>
                            <Tooltip title="Edit Language/Category">
                                <IconButton
                                    aria-label="edit video details"
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation(); // 👈 13. PREVENT card click
                                        setShowEditVideo(true)
                                        setSelectedVideoDetails({ languageList, categoryList, videoContentType, id })
                                    }}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={active ? "Disable Video" : "Enable Video"}>
                                <Switch
                                    size="small"
                                    checked={active}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        handleStatusChange(e);
                                    }}
                                    color="primary"
                                />
                            </Tooltip>
                        </Box>

                        {/* Right-aligned Edit Button */}

                    </CardActions>
                </div>

                <EditVideo
                    show={showEditVideo}
                    selectedVideoDetails={selectedVideoDetails}
                    getVideoList={getVideoList}
                    onHide={() => setShowEditVideo(false)}
                />
            </Card>
        </>
    );
}